module.exports = __webpack_public_path__ + "img/platinum-punch-4-scaled.a0be1b93.jpeg";